module.exports = __webpack_public_path__ + "img/2018-min.bd616a87.jpg";